module.exports = __webpack_public_path__ + "static/media/Asset.bb1edce1.svg";